import PublisherPayoutsActions from '../../../../actions/PublisherPayoutsActions';
import AppConstants from '../../../../constants/AppConstants';

export const actions = {
    getPayout(id) {
        let params = {
            ids: id,
            fields: 'publisher_payout.currency_ratio,publisher_payout.sum_original,publisher_payout.fee,publisher_payout.payment_method_details,publisher_payout.comment,publisher_payout.from_dt,publisher_payout.created_at,publisher_payout.created_at_formatted,publisher_payout.updated_at,publisher_payment_details.created_at,publisher_payment_details.updated_at,currency_ratio.rates'
        };

        PublisherPayoutsActions.getPayouts(params, null, {
            before: AppConstants.PAYOUTS_SEARCH_START_LOADING,
            success: AppConstants.PAYOUTS_SEARCH_ITEM_SUCCESS
        });
    },
};
